import { render, staticRenderFns } from "./stock-add.vue?vue&type=template&id=025e99ce&"
import script from "./stock-add.vue?vue&type=script&lang=ts&"
export * from "./stock-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports